/**
 * Regular expressions for detecting different types of content in text
 */
export const CONTENT_PATTERNS = {
  URL: /(https?:\/\/[^\s]+|ftp:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})*(?:\/[^\s]*)?)/gi,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
} as const;

// Fallback pattern captures any @mention-like token (even if not in the cache) up to the next @ or end of string.
export const unknownHandlePattern = '@[^@]+?(?=\\s*@|$)';
